import {
  GET,
  POST
} from "@/axios/axios"

export const services = {

  getIndustryAndSceneLabel: () => {   // 行业分类-服务场景-二级联动
    return GET('/backend/taskTemplate/getIndustryAndSceneLabel')
  },
  getIndustryList: () => {   // 行业分类下拉框
    return GET('/backend/taskTemplate/getIndustryList')
  },
  getSceneList: (param) => {   // 服务场景下拉框
    return GET('/backend/taskTemplate/getSceneList', param)
  },
  getIndustryAndSceneList: (param) => {   // 任务类型列表
    return GET('/backend/taskTemplate/getIndustryAndSceneList', param)
  },

  createIndustryAndScene: (param) => { // 创建行业分类和服务场景
    return POST("/backend/taskTemplate/createIndustryAndScene", param);
  },
  updateIndustryAndScene: (param) => { // 修改行业分类和服务场景
    return POST("/backend/taskTemplate/updateIndustryAndScene", param);
  },
  updateIndustry: (param) => { // 修改行业分类
    return POST("/backend/taskTemplate/updateIndustry", param);
  },
  updateScene: (param) => { // 修改服务场景
    return POST("/backend/taskTemplate/updateScene", param);
  },
  deleteIndustryOrScene: (param) => { // 删除行业分类或服务场景
    return POST("/backend/taskTemplate/deleteIndustryOrScene", param);
  },
  getTaskTemplate: (param) => {   // 任务示例列表
    return GET('/backend/taskTemplate/getTaskTemplate', param)
  },

  createTaskTemplate: (param) => { // 新增任务示例
    return POST("/backend/taskTemplate/createTaskTemplate", param);
  },
  updateTaskTemplate: (param) => { // 修改任务示例
    return POST("/backend/taskTemplate/updateTaskTemplate", param);
  },
  deleteTaskTemplate: (param) => { // 删除任务示例
    return POST("/backend/taskTemplate/deleteTaskTemplate", param);
  },


}

export default services;



// WEBPACK FOOTER //
// ./src/service/services/taskManage.js